// extracted by css-extract-rspack-plugin
export default {"BypassGroup":"BypassToggle-module__BypassGroup__CjhgB"};